/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

module.exports = Odigeo.View.extend({
    ignoreModelUpdate: false,
    events: {
        'change .accommodationTypeFilter': 'accommodationTypeSelection',
        'change .accommodationTypeFilter:checked': trackClickEvent,
        'tap .clean_selector': 'getCleanSelection',
        'tap .filter_collapsible_expand': 'onFilterCollapsible',
    },
    selectors: {
        inputsContainer: '#filterByAccommodationType',
        template: '.filterByAccommodationTypeTemplate',
    },
    trackingUtils: require('../utils/tracking.utils'),
    inputTagSelector: '#type-##tagName##',
    data: {
        accommodationTypes: [
            'APARTAMENT',
            'BED_AND_BREAKFAST',
            'GUEST_HOUSE',
            'HOSTEL',
            'HOTEL',
            'MOTEL',
            'RESIDENCE',
            'RESORT',
            'RYOKAN',
            'UNKNOWN',
        ],
    },

    init: function() {
        var tmplFnc = Odigeo._.template(this.$cachedSelectors.template.html(), Odigeo.Utils.getTmplSettings());

        this.$cachedSelectors.inputsContainer.html(tmplFnc(this.data));
        this.$el.on('updateFilterStatus.accommodationfilter', Odigeo._.bind(this.model.updateFilterStatus, this.model));
        this.$el.on('resetFilterStatus.accommodationfilter', Odigeo._.bind(this.cleanTypeFilter, this));
    },

    accommodationTypeSelection: function(ev) {
        var $selectedAccommodationType = $(ev.target);
        var isSelected = $selectedAccommodationType.is(':checked');
        var actionLabel = isSelected ? 'checked_' : 'unchecked_';

        this.sendToFather({
            accommodationTypeModel: [{selectedItems: this.retrieveSelectedAccommodationType()}],
        });
        this.trackingUtils.trackEvent('results_filters_hotels',
            'accommodation_type_' + actionLabel + $selectedAccommodationType.data('type').toLowerCase());
        $selectedAccommodationType.data('selected', isSelected);
        this.$el.find('.clean_selector').removeClass('active');
    },

    retrieveSelectedAccommodationType: function() {
        return Odigeo._.reduce(this.$cachedSelectors.inputsContainer.find('input:checked'), function(memo, value) {
            return memo.concat($(value).data('type'));
        }, []);
    },

    cleanTypeFilter: function(ev, tagName) {
        this.resetInputAccommodationType(tagName);
        this.sendToFather({
            accommodationTypeModel: [{selectedItems: this.retrieveSelectedAccommodationType()}],
        });
    },

    resetInputAccommodationType: function(tagName) {
        this.$el.find((this.inputTagSelector.replace('##tagName##', tagName)))
            .prop('checked', false)
            .data('selected', false);
    },

    sendToFather: function(msg) {
        this.$el.trigger('filterHasChanged.accommodationfilter', msg);
    },

    render: function() {
        // Update the view with the new values that the model has.
        Odigeo._.each(this.model.get('items'), function(changedValue, key) {
            var $el = this.$('#type_name_' + key);
            var valueIsZero = +changedValue === 0;
            var $input = $el.closest('label').siblings('input');

            $el.text('(' + changedValue + ')');
            $input.prop('disabled', valueIsZero);
            $input.prop('checked', valueIsZero ? false : !!$input.data('selected'));
        }, this);

        this.resetView(this.model.get('isResetRequested'));

        return this;
    },

    resetView: function(isResetRequested) {
        if (isResetRequested) {
            this.getResetAllCheckbox();
        }
    },

    getResetAllCheckbox: function() {
        Odigeo._.each(this.$cachedSelectors.inputsContainer.find('input:not([disabled])'), function(el) {
            $(el).prop('checked', false).data('selected', false);
        });
    },

    getCleanSelection: function() {
        if (!this.$el.find('.clean_selector').hasClass('active')) {
            this.getResetAllCheckbox();
            this.activedCleanSelector();
            this.sendToFather({
                accommodationTypeModel: [{selectedItems: this.retrieveSelectedAccommodationType()}],
            });
        }
    },

    activedCleanSelector: function() {
        this.trackingUtils.trackEvent('results_filters_hotels',
            'accommodation_type_select_none_clicks');
        this.$el.find('.clean_selector').addClass('active');
    },

    onFilterCollapsible: function() {
        var collapsibleContent = this.$el.find('.filter_collapsible_content');
        var isOpen;

        collapsibleContent.toggleClass('open');

        isOpen = collapsibleContent.hasClass('open');
        this.trackingUtils.trackEvent('results_filters_hotels', (isOpen ? 'open' : 'close') + '_accommodation_type');
        this.getArrowCollapsible(isOpen);
    },

    getArrowCollapsible: function(isOpen) {
        this.$el.find('.filter_collapsible_arrow')
            .removeClass('odf-icon-arrow-down odf-icon-arrow-up')
            .addClass(isOpen ? 'odf-icon-arrow-up' : 'odf-icon-arrow-down');
    },
});
